module.exports = __webpack_public_path__ + "static/img/bg2.dd90e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/bg2.png
// module id = S4Og
// module chunks = 70